<template>
  <button
    class="dingButton"
    :class="[
      buttonSize ? `ding-btn-${buttonSize}` : '',
      {
        'is-disabled': disabled,
        'is-plain': plain,
        'is-disabled-plain': disabled && plain
      }
    ]"
    @click="handleClick"
    :disabled="disabled"
  >
    {{ content }}
  </button>
</template>
<script>
export default {
  name: 'DingButton',

  props: {
    disabled: {
      type: Boolean,
      default: !1,
    },
    content: {
      type: String,
      default: 'button',
    },
    plain: {
      type: Boolean,
      default: !1,
    },
    size: {
      type: String,
      default: 'medium',
    },
  },

  computed: {
    buttonSize() {
      return this.size;
    },

  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variable.scss";

.dingButton{
  // height: 92px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: $defaultTheme;
  border: 1PX solid $defaultTheme;
  border-color: $defaultTheme;
  color: #ffffff;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  -webkit-transition: .1s;
  transition: .1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 8px 20px;
  font-size: 36px;
  border-radius: 6px;
  outline: none;
  border-radius: 22px;
  width: 144px;
  height: 38px;
  background-color: #3d9efe;
  -webkit-box-shadow: inset 0 -4px 0 0 #2d8ff0;
  box-shadow: inset 0 -4px 0 0 #2d8ff0;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  &:active{
    background: #027ce5;
    color: #8fc5f4;
    border: 1PX solid #027ce5;
  }
}
.is-disabled-plain{
  background: #F2F4F5;
  color: #c5c5c5;
  border: 1PX solid rgba(17,31,44,0.08);
}
.is-disabled{
  background: $disableBtn;
  color: #ffffff;
  border: 1PX solid rgba(25,31,37,0.12);
  &:active{
    background: $disableBtn!important;
    color: #ffffff!important;
    border: 1PX solid rgba(25,31,37,0.12)!important;
  }
}
.is-plain{
  background: #F2F4F5;
  color: #111F2C;
  border: 1PX solid rgba(17,31,44,0.08);
}
.ding-btn-medium{ width: 100%;}
.ding-btn-large{width: 686px;}
.ding-btn-small{width: 494px;}
.ding-btn-smaller{width: 430px;}
.ding-btn-mini{width: 328px;}
// update
</style>
